import React, { useEffect, useMemo } from "react";

import { useTranslation } from "react-i18next";

import LoaderSpinner from "@components-shared/LoaderSpinner";
import AdminLayoutWrapper from "@components/layout/AdminLayoutWrapper";
import { ConfigType } from "@data-types/use-scroll-restoration/useScrollRestoration";
import { useRootAppStore } from "@hooks";
import { useScrollRestoration } from "@hooks/useScrollRestoration";
import { WithdrawalContext } from "@state/context/payment/WithdrawalContext";
import { WithdrawalStore } from "@state/stores/payment/withdrawal";
import { setTabTitle } from "@utils";
import { observer } from "mobx-react";

import WithdrawalTabs from "./tabs/WithdrawalTabs";

export default observer(function WithdrawalPage() {
	const { t } = useTranslation("payment");
	const rootStore = useRootAppStore();

	const withdrawalStore = useMemo(() => new WithdrawalStore(rootStore), []);

	useEffect(() => {
		const fetchData = async () => {
			setTabTitle(t("WITHDRAWAL.TITLE"));

			withdrawalStore.onInitialize();
			return () => withdrawalStore.onDispose();
		};

		fetchData();
	}, []);

	useScrollRestoration({
		type: ConfigType.Basic,
		isLoading:
			withdrawalStore.isLoading ||
			withdrawalStore.isLoadingProcess ||
			!withdrawalStore.isStoreInitialized,
	});

	return (
		<AdminLayoutWrapper>
			<WithdrawalContext.Provider value={withdrawalStore}>
				<LoaderSpinner isLoading={withdrawalStore.isLoading} />
				<div className="container">
					<WithdrawalTabs />
				</div>
			</WithdrawalContext.Provider>
		</AdminLayoutWrapper>
	);
});
